import { ToastContainer, Toast, Alert, Spinner, Row, Col, Button, Badge } from "react-bootstrap";
import CustomerCard from "../customer-card";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faPhoneSlash } from "@fortawesome/free-solid-svg-icons";
import { Component } from "preact";
import { getCustomerByField, getCustomer } from "../../api/customers";
import { formatMobilePhone } from "../../lib/format";

export default class CallToast extends Component {
    state = {
        ago: 1,
        customerLoading: true,
    };

    componentDidMount() {
        this.loadCustomer();

        this.agoInterval = setInterval(() => {
            let ago = moment().diff(moment(this.props.call.createdAt), "seconds");
            let establishedAgo = moment().diff(moment(this.props.call.establishedAt ?? 0), "seconds");
            this.setState({ ago, establishedAgo });
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.agoInterval);
    }

    loadCustomer = () => {
        let handleResponse = (response) => {
            const respData = response.data;

            if (respData.success === true) {
                let data = respData.data;
                let customer = null;

                if (Array.isArray(data)) {
                    customer = data?.[0];
                } else {
                    customer = data;
                }

                this.setState({ customer: customer, customerLoading: false });
            } else {
                this.setState({ customer: false, customerLoading: false });
            }
        };

        let handleError = (ex) => {
            console.log("ex", ex);
            this.setState({ customerLoading: false });
        };

        if (["incoming", "outgoing"].includes(this.props.call.type)) {
            let phone = null;

            switch (this.props.call.type) {
                case "incoming":
                    phone = this.props.call.from;
                    break;
                case "outgoing":
                    phone = this.props.call.to;
                    break;
            }

            if (phone) {
                getCustomerByField("mobile_phone", formatMobilePhone(phone), { useCache: 1 }).then(handleResponse).catch(handleError);
            } else {
                this.setState({ customerLoading: false });
            }
        } else {
            getCustomer(this.props.call.metadata?.customerId).then(handleResponse).catch(handleError);
        }
    };

    getTitle = () => {
        if (this.props.call.type === "automate") {
            return `Appel automatique`;
        } else if (this.props.call.type === "incoming") {
            return `Appel entrant`;
        } else if (this.props.call.type === "outgoing") {
            return `Appel sortant`;
        } else {
            return `Appel`;
        }
    };

    render(props) {
        const call = props.call;
        const type = props.call?.type;

        return (
            <>
                <ToastContainer className="p-3 unset-top" position={`top-end`}>
                    <Toast onClose={this.props.onClose}>
                        <Toast.Header closeButton={true}>
                            <strong className="me-auto">{this.getTitle()}</strong>
                            <small>Il y a {this.state.ago} secondes</small>
                        </Toast.Header>
                        <Toast.Body>
                            {type === "incoming" ? (
                                <div>
                                    <strong>De:</strong> {formatMobilePhone(call?.from)}
                                </div>
                            ) : null}

                            {type === "outgoing" ? (
                                <div>
                                    <strong>Vers: </strong> {formatMobilePhone(call?.to)}
                                </div>
                            ) : null}

                            {type === "automate" ? (
                                <div>
                                    <div>
                                        <strong>Vers:</strong> {call?.to ?? this.state.customer?.mobile_phone ?? "..."}
                                    </div>
                                    <div>
                                        <strong>
                                            Status:{" "}
                                            {call.establishedAt ? (
                                                <Badge bg="success">En communication ({this.state.establishedAgo}s)</Badge>
                                            ) : (
                                                <Badge bg="info">En cours...</Badge>
                                            )}
                                        </strong>
                                    </div>
                                </div>
                            ) : null}

                            <hr />

                            {this.state.customer ? (
                                <CustomerCard customer={this.state.customer} short={true} />
                            ) : (
                                <>
                                    {this.state.customerLoading ? (
                                        <>
                                            <div className={`d-flex justify-content-center`}>
                                                <Spinner animation="border" size="sm" />
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <Alert variant="warning">Impossible de trouver le client</Alert>
                                        </>
                                    )}
                                </>
                            )}
                            {["incoming", "outgoing"].includes(type) ? (
                                <>
                                    <hr />
                                    <Row>
                                        {/* <Col>
                                            <Button disabled={true} className={`w-100`} variant="success" onClick={() => this.props.onAnswer()}>
                                                <FontAwesomeIcon icon={faPhone} /> Répondre
                                            </Button>
                                        </Col>*/}

                                        <Col lg="12">
                                            <Button className={`w-100`} variant="danger" onClick={() => this.props.onHangUp()}>
                                                <FontAwesomeIcon icon={faPhoneSlash} />
                                                Racrocher
                                            </Button>
                                        </Col>
                                    </Row>
                                </>
                            ) : null}
                        </Toast.Body>
                    </Toast>
                </ToastContainer>
            </>
        );
    }
}
